import React from 'react';

const ImageMockup = ({image, caption}) => (
  <div className="portfolio-img align-center">
    <img className="hero-img" src={image} alt={caption}/>
  </div>
);

export default ImageMockup;



// WEBPACK FOOTER //
// ./src/layout/portfolio/ImageMockup.js